@import 'drinks/drinks-light';
@import "output1/output1-light";
@import "grinder/grinder-light";
@import "milk-steamer/milk-steamer-light";
@import "parameters/parameters-light";
@import "modal/modal-light";

//$editor-box-background:'white';
$editor-box-border: '#858A8D';
$editor-divider-color: '#DCDDDF';
$editor-header-color: '#161C1F';
$editor-header-icon-color: '#599AB6';

$editor-output-toggle-background:'#6F7E8D';
$editor-output-toggle-color:'white';
$editor-output-toggle-border:'#868C8D';
$editor-output-toggle-text-stroke:'#6F7E8D';

$editor-output-delete-button-color:'white';
$editor-output-delete-button-border:'#90979d';
$editor-output-delete-button-background:'#6f7e8d';

.box {
  background-size: 6px 6px !important;
  background-image: linear-gradient(-45deg, #D6D9DE 46%, #CBCED3 49%, #CBCED3 51%, #D6D9DE 55%) !important;

  .vertical-divider {
    border-right: 2px solid #858A8D;
    border-left: 2px solid #858A8D;
    border-bottom: 2px solid #DCDDDF;
    margin-top: -2px;
    margin-bottom: -2px;
    z-index: 1;
    position: relative;
  }
}

@import "editor-theme";


// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-dev-vm-baristadj/src/app/components/recipe/editor/editor-light.scss